export const renderSiteName = (name: string, alias: string) => {
    if (alias) {
        return alias;
    }
    return name;
};

export default renderSiteName;
